// extracted by mini-css-extract-plugin
export default {"simulateButton":"ResetSimulationParametersButton_simulateButton__ko7gp"};